module.exports = __webpack_public_path__ + "img/seller2.d1da329e.jpg";